<template>
    <profile-layout title="Profile">

        <template v-slot:user-information>
            <AccountData :user="user" />
        </template>

        <template v-slot:provider>
            <Providers
            :data="providers"
            :toggleCreateProviderModal="toggleCreateProviderModal"
            :toggleEditProviderModal="toggleEditProviderModal"
            />
        </template>

    </profile-layout>

    <CreateProviderModal
    :showModal="createProviderModalShow"
    :toggleModal="toggleCreateProviderModal"
    />

    <EditProviderModal
    :showModal="editProviderModalShow"
    :toggleModal="toggleEditProviderModal"
    :provider_id="editModalProviderId"
    />

    <PreviewProviderModal
    :showModal="previewProviderModalShow"
    :toggleModal="toggleEditProviderModal"
    :provider_id="editModalProviderId"
    />

</template>

<script>
import ProfileLayout from '@/Layouts/ProfileLayout.vue'
import AccountData from '@/Pages/User/Partials/AccountData'
import Providers from './Partials/Providers'
import CreateProviderModal from './Partials/CreateProviderModal'
import EditProviderModal from './Partials/EditProviderModal'
import PreviewProviderModal from './Partials/PreviewProviderModal'

import DeleteProviderModal from '@/Modals/DeleteProviderModal.vue'

export default {
    components: {
        ProfileLayout,
        AccountData,
        Providers,
        CreateProviderModal,
        EditProviderModal,
        PreviewProviderModal
    },

    props: {
        userResource: Object,
    },
    data() {
        return {
            user: this.userResource.data,
            providers: this.$page.props.providers.data,
            createProviderModalShow: false,
            editProviderModalShow: false,
            deleteProvideModalShow: false,
            delete_provider_id: null,
            delete_button_disabled: this.$page.props.userResource.data.providers.length == 1 ? true : false,
            editModalProviderId: null,
            previewProviderModalShow: false,
        }
    },
    updated() {
        this.user = this.userResource.data
        this.providers = this.$page.props.providers.data
    },
    methods: {
        toggleCreateProviderModal() {
            if(this.createProviderModalShow == false){
                this.createProviderModalShow = true;
            } else {
                this.createProviderModalShow = false;
            }
        },
        editProviderPopUp() {
            console.log('provider Edit')
        },
        deleteProviderModal(e) {
            this.delete_provider_id = e.target.getAttribute('data-id')
            this.deleteProvideModalShow = true;
        },
        deleteProviderToggleModal(value){
            this.deleteProvideModalShow = value;
        },
        toggleEditProviderModal(e, provider) {

            //if user is admin open edit provider modal
            if(provider && provider.auth_user_role == 'admin')
            {
                if(this.editProviderModalShow == false){
                    this.editProviderModalShow = true;
                    this.editModalProviderId = provider.id;
                }
                return;
            }
            //if user is editor open preview provider modal
            if(provider && provider.auth_user_role == 'editor')
            {
                if(this.previewProviderModalShow == false){
                    this.previewProviderModalShow = true;
                    this.editModalProviderId = provider.id;
                }
                return;
            }

            this.editProviderModalShow = false;
            this.previewProviderModalShow = false;
            this.editModalProviderId = null;
        },
    }
}
</script>
